module.exports = __webpack_public_path__ + "media/images/fill-2@2x-7525f0449cfc2839e231d5b7067e93f9.png";